import { useState } from 'react';
import { LetterType, WordType } from '../types/SharedTypes';

type UseFilterProps = {
	data: {
		words: Record<string, WordType[]>;
	};
};

export const useFilter = (props: UseFilterProps) => {
	const { data } = props;
	const [filter, setFilter] = useState<LetterType | null>(null);

	const handleFilterChange = (letter: LetterType | null) => {
		setFilter(letter);
	};

	const getFilteredWords = () => {
		if (!filter) {
			return data.words || {};
		}
		return { [filter]: data.words[filter] || [] };
	};

	return {
		filter,
		setFilter: handleFilterChange,
		getFilteredWords,
	};
};
